import { useEffect, useState } from 'react';
import { IonModal, IonButton, IonIcon, IonImg, IonRange, IonLabel, IonList, IonItem, IonCheckbox } from '@ionic/react';
import { close } from 'ionicons/icons';
import { AirlinesFlights, StopsFlights } from '../../../defines/Functions';
import { Constants } from '../../../defines/Constants';
import { MinutesToTime, PriceFlightsLimit, DurationFlightsLimit } from '../../../defines/Functions';
import Loading from '../../Loading';
import './FlightFilter.css';
import CurrencyFormat from 'react-currency-format';
import eclipse from '../../../assets/images/eclipse.svg';
import sunrise from '../../../assets/images/sunrise.svg';
import sun from '../../../assets/images/sun.svg';
import sunset from '../../../assets/images/sunset.svg';
import sunhaze from '../../../assets/images/sunhaze.svg';
import moonstars from '../../../assets/images/moonstars.svg';
import filterImg from '../../../assets/images/filter-filter.svg';

const timesListWent = [
    { icon: eclipse, value: 1, title: 'صبح زود', subTitle: 'قبل از 8', checked: false },
    { icon: sunrise, value: 2, title: 'صبح', subTitle: '8 تا 11', checked: false },
    { icon: sun, value: 3, title: 'ظهر', subTitle: '11 تا 14', checked: false },
    { icon: sunset, value: 4, title: 'بعد از ظهر', subTitle: '14 تا 17', checked: false },
    { icon: sunhaze, value: 5, title: 'عصر', subTitle: '17 تا 21', checked: false },
    { icon: moonstars, value: 6, title: 'شب', subTitle: 'بعد از 21', checked: false }
];
const timesListReturn = [
    { icon: eclipse, value: 1, title: 'صبح زود', subTitle: 'قبل از 8', checked: false },
    { icon: sunrise, value: 2, title: 'صبح', subTitle: '8 تا 11', checked: false },
    { icon: sun, value: 3, title: 'ظهر', subTitle: '11 تا 14', checked: false },
    { icon: sunset, value: 4, title: 'بعد از ظهر', subTitle: '14 تا 17', checked: false },
    { icon: sunhaze, value: 5, title: 'عصر', subTitle: '17 تا 21', checked: false },
    { icon: moonstars, value: 6, title: 'شب', subTitle: 'بعد از 21', checked: false }
];

interface Props {
    data: any,
    flightFilterParentCallback: Function,
    filters: any,
    searchType: string,
    disabled?: boolean
    type?: string,
}
const initialState = {
    showFlightFilterModal: false,
    routeWent: {
        airlinesRouteWent: [] as any,
        stopsRouteWent: [] as any,
        timesRouteWent: [] as any,
        durationRouteWent: {
            min: 0 as number,
            max: 0 as number,
            lower: 0 as number,
            upper: 0 as number
        }
    },
    routeReturn: {
        airlinesRouteReturn: [] as any,
        stopsRouteReturn: [] as any,
        timesRouteReturn: [] as any,
        durationRouteReturn: {
            min: 0 as number,
            max: 0 as number,
            lower: 0 as number,
            upper: 0 as number
        }
    },
    ticketPrice: {
        min: 0 as number,
        max: 0 as number,
        lower: 0 as number,
        upper: 0 as number
    }
};
const FlightFilter = (item: Props) => {
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        ...initialState
    });
    useEffect(() => {
        if (state.showFlightFilterModal) {
            if (item.data.pricedItineraries) {
                let flightWentStopsArr = [] as any;
                let flightWentAirlinesArr = [] as any;
                let flightReturnStopsArr = [] as any;
                let flightReturnAirlinesArr = [] as any;
                StopsFlights(item.data.pricedItineraries.pricedItinerary, 'went').forEach(aiItem => {
                    let checked = false;
                    let index = item.filters.routeWent.stopsRouteWent.findIndex((x: any) => x.value === aiItem);
                    if (index !== -1) {
                        checked = true;
                    }
                    if (aiItem === 0) {
                        flightWentStopsArr.push({ value: aiItem, title: 'بدون توقف', checked: checked });
                    } else {
                        flightWentStopsArr.push({ value: aiItem, title: aiItem + ' توقف', checked: checked });
                    }
                });
                AirlinesFlights(item.data.pricedItineraries.pricedItinerary, 'went').forEach(aiItem => {
                    let checked = false;
                    let index = item.filters.routeWent.airlinesRouteWent.findIndex((x: any) => x.code === aiItem.code);
                    if (index !== -1) {
                        checked = true;
                    }
                    flightWentAirlinesArr.push({ code: aiItem.code, name: aiItem.name, checked: checked });
                });
                if (item.searchType === 'roundtrip') {
                    StopsFlights(item.data.pricedItineraries.pricedItinerary, 'return').forEach(aiItem => {
                        let checked = false;
                        let index = item.filters.routeReturn.stopsRouteReturn.findIndex((x: any) => x.value === aiItem);
                        if (index !== -1) {
                            checked = true;
                        }
                        if (aiItem === 0) {
                            flightReturnStopsArr.push({ value: aiItem, title: 'بدون توقف', checked: checked });
                        } else {
                            flightReturnStopsArr.push({ value: aiItem, title: aiItem + ' توقف', checked: checked });
                        }
                    });
                    AirlinesFlights(item.data.pricedItineraries.pricedItinerary, 'return').forEach(aiItem => {
                        let checked = false;
                        let index = item.filters.routeReturn.airlinesRouteReturn.findIndex((x: any) => x.code === aiItem.code);
                        if (index !== -1) {
                            checked = true;
                        }
                        flightReturnAirlinesArr.push({ code: aiItem.code, name: aiItem.name, checked: checked });
                    });
                }
                let isPriceFilter = false;
                let isDurationWentFilter = false;
                const priceLimit = PriceFlightsLimit(item.data.pricedItineraries.pricedItinerary);
                const durationLimitWent = DurationFlightsLimit(item.data.pricedItineraries.pricedItinerary, 'went');
                if (item.filters.ticketPrice.lower !== 0 || item.filters.ticketPrice.upper !== 0) {
                    priceLimit.min = item.filters.ticketPrice.lower;
                    priceLimit.max = item.filters.ticketPrice.upper;
                    isPriceFilter = true;
                }
                if (item.filters.routeWent.durationRouteWent.lower !== 0 || item.filters.routeWent.durationRouteWent.upper !== 0) {
                    durationLimitWent.min = item.filters.routeWent.durationRouteWent.lower;
                    durationLimitWent.max = item.filters.routeWent.durationRouteWent.upper;
                    isDurationWentFilter = true;
                }
                const priceRangeEl: any = document.querySelector('#priceRange');
                const durationWentRangeEl: any = document.querySelector('#durationWentRange');
                let checkExistPrice = setInterval(function () {
                    if (priceRangeEl) {
                        priceRangeEl.value = { lower: priceLimit.min, upper: priceLimit.max };
                        clearInterval(checkExistPrice);
                    }
                }, 10);
                let checkExistDurationWent = setInterval(function () {
                    if (durationWentRangeEl) {
                        durationWentRangeEl.value = { lower: durationLimitWent.min, upper: durationLimitWent.max };
                        clearInterval(checkExistDurationWent);
                    }
                }, 10);
                let myRangeMinMax = {
                    ticketPrice: {
                        min: priceLimit.min,
                        max: priceLimit.max
                    },
                    durationWent: {
                        min: durationLimitWent.min,
                        max: durationLimitWent.max
                    },
                    durationReturn: {} as any
                };
                if (isPriceFilter) {
                    myRangeMinMax.ticketPrice.min = state.ticketPrice.min;
                    myRangeMinMax.ticketPrice.max = state.ticketPrice.max;
                }
                if (isDurationWentFilter) {
                    myRangeMinMax.durationWent.min = state.routeWent.durationRouteWent.min;
                    myRangeMinMax.durationWent.max = state.routeWent.durationRouteWent.max;
                }
                setState({
                    ...state,
                    routeWent: {
                        ...state.routeWent,
                        airlinesRouteWent: flightWentAirlinesArr,
                        stopsRouteWent: flightWentStopsArr,
                        durationRouteWent: { lower: durationLimitWent.min, upper: durationLimitWent.max, min: myRangeMinMax.durationWent.min, max: myRangeMinMax.durationWent.max }
                    },
                    ticketPrice: { lower: priceLimit.min, upper: priceLimit.max, min: myRangeMinMax.ticketPrice.min, max: myRangeMinMax.ticketPrice.max }
                });
                if (item.searchType === 'roundtrip') {
                    let isDurationReturnFilter = false;
                    const durationLimitReturn = DurationFlightsLimit(item.data.pricedItineraries.pricedItinerary, 'return');
                    if (item.filters.routeReturn.durationRouteReturn.lower !== 0 || item.filters.routeReturn.durationRouteReturn.upper !== 0) {
                        durationLimitReturn.min = item.filters.routeReturn.durationRouteReturn.lower;
                        durationLimitReturn.max = item.filters.routeReturn.durationRouteReturn.upper;
                        isDurationReturnFilter = true;
                    }
                    const durationRerutneRangeEl: any = document.querySelector('#duratioReturnRange');
                    let checkExistDurationReturn = setInterval(function () {
                        if (durationRerutneRangeEl) {
                            durationRerutneRangeEl.value = { lower: durationLimitReturn.min, upper: durationLimitReturn.max };
                            clearInterval(checkExistDurationReturn);
                        }
                    }, 10);
                    myRangeMinMax.durationReturn = {
                        min: durationLimitReturn.min,
                        max: durationLimitReturn.max
                    }
                    if (isDurationReturnFilter) {
                        myRangeMinMax.durationReturn.min = state.routeReturn.durationRouteReturn.min;
                        myRangeMinMax.durationReturn.max = state.routeReturn.durationRouteReturn.max;
                    }
                    setState({
                        ...state,
                        routeWent: {
                            ...state.routeWent,
                            airlinesRouteWent: flightWentAirlinesArr,
                            stopsRouteWent: flightWentStopsArr,
                            durationRouteWent: { lower: durationLimitWent.min, upper: durationLimitWent.max, min: myRangeMinMax.durationWent.min, max: myRangeMinMax.durationWent.max }
                        },
                        routeReturn: {
                            ...state.routeReturn,
                            airlinesRouteReturn: flightReturnAirlinesArr,
                            stopsRouteReturn: flightReturnStopsArr,
                            durationRouteReturn: { lower: durationLimitReturn.min, upper: durationLimitReturn.max, min: myRangeMinMax.durationReturn.min, max: myRangeMinMax.durationReturn.max }
                        },
                        ticketPrice: { lower: priceLimit.min, upper: priceLimit.max, min: myRangeMinMax.ticketPrice.min, max: myRangeMinMax.ticketPrice.max }
                    })
                }
            }
        }
        setLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.showFlightFilterModal]);
    const checkAll = (querySelector: string) => {
        document.querySelectorAll('.' + querySelector + ' ion-checkbox').forEach((item: any) => {
            if (!item.checked) {
                item.checked = true;
            }
        })
    }
    const unCheckAll = (querySelector: string) => {
        document.querySelectorAll('.' + querySelector + ' ion-checkbox').forEach((item: any) => {
            if (item.checked) {
                item.checked = false;
            }
        })
    }
    const checkCheckbox = (type: string, index: number, value: boolean) => {
        let checkboxItems = [] as any;
        if (type === 'stop-went-checkbox') {
            checkboxItems = state.routeWent.stopsRouteWent;
            checkboxItems[index].checked = value;
            setState({ ...state, routeWent: { ...state.routeWent, stopsRouteWent: checkboxItems } });
        } else if (type === 'airline-went-checkbox') {
            checkboxItems = state.routeWent.airlinesRouteWent;
            checkboxItems[index].checked = value;
            setState({ ...state, routeWent: { ...state.routeWent, airlinesRouteWent: checkboxItems } });
        } else if (type === 'time-went-checkbox') {
            checkboxItems = timesListWent;
            checkboxItems[index].checked = value;
            setState({ ...state, routeWent: { ...state.routeWent, timesRouteWent: checkboxItems } });
        } else if (type === 'stop-return-checkbox') {
            checkboxItems = state.routeReturn.stopsRouteReturn;
            checkboxItems[index].checked = value;
            setState({ ...state, routeReturn: { ...state.routeReturn, stopsRouteReturn: checkboxItems } });
        } else if (type === 'airline-return-checkbox') {
            checkboxItems = state.routeReturn.airlinesRouteReturn;
            checkboxItems[index].checked = value;
            setState({ ...state, routeReturn: { ...state.routeReturn, airlinesRouteReturn: checkboxItems } });
        } else if (type === 'time-return-checkbox') {
            checkboxItems = timesListReturn;
            checkboxItems[index].checked = value;
            setState({ ...state, routeReturn: { ...state.routeReturn, timesRouteReturn: checkboxItems } });
        }
    }
    const setRangeSlider = (type: string, value: any) => {
        if (type === 'price-range') {
            setState({ ...state, ticketPrice: { ...state.ticketPrice, lower: value.value.lower, upper: value.value.upper } });
        }
        if (type === 'duration-went-range') {
            setState({ ...state, routeWent: { ...state.routeWent, durationRouteWent: { ...state.routeWent.durationRouteWent, lower: value.value.lower, upper: value.value.upper } } });
        }
        if (type === 'duration-return-range') {
            setState({ ...state, routeReturn: { ...state.routeReturn, durationRouteReturn: { ...state.routeReturn.durationRouteReturn, lower: value.value.lower, upper: value.value.upper } } });
        }
    }
    const flightFilterParentCallback = () => {
        item.flightFilterParentCallback(state);
    }
    const onConfirmModal = () => {
        flightFilterParentCallback();
        setState({ ...state, showFlightFilterModal: false });
    }
    const onOpenModal = () => {
        setLoading(true);
        setTimeout(() => {
            setState({ ...state, showFlightFilterModal: true });
        }, 200);
    }
    return (
        <>
            {!loading ?
                <IonModal isOpen={state.showFlightFilterModal} onDidDismiss={() => setState({ ...state, showFlightFilterModal: false })} mode="ios" cssClass="flight-filter-modal">
                    <div className="flight-filter-modal-content">
                        <h3 className="flight-filter-modal-title">
                            فیلتر نتایج
                            <IonIcon icon={close} onClick={() => setState({ ...state, showFlightFilterModal: false })} />
                        </h3>
                        <div className="flight-filter-modal-items ion-margin-top">
                            {item.type !== 'flightHotel' &&
                                <div className="flight-filter-modal-box">
                                    <span className="my-title">
                                        تعداد توقف {item.searchType === 'roundtrip' && '(پرواز رفت)'}
                                    </span>
                                    <div>
                                        <IonLabel onClick={() => checkAll('stops-went-checkbox')}>انتخاب همه</IonLabel>
                                        /
                                        <IonLabel onClick={() => unCheckAll('stops-went-checkbox')}>لغو انتخاب همه</IonLabel>
                                    </div>
                                    <IonList lines="none" className="stops-went-checkbox">
                                        {state.routeWent.stopsRouteWent.map((item: any, index: number) =>
                                            <IonItem lines="none" key={'index' + index}>
                                                <span>
                                                    <IonCheckbox color="warning" value={item.value} checked={item.checked} onIonChange={(e) => checkCheckbox('stop-went-checkbox', index, e.detail.checked)} />
                                                    {item.title}
                                                </span>
                                            </IonItem>
                                        )}
                                    </IonList>
                                </div>
                            }
                            {item.searchType === 'roundtrip' &&
                                item.type !== 'flightHotel' &&
                                <div className="flight-filter-modal-box">
                                    <span className="my-title">
                                        تعداد توقف (پرواز برگشت)
                                    </span>
                                    <div>
                                        <IonLabel onClick={() => checkAll('stops-return-checkbox')}>انتخاب همه</IonLabel>
                                        /
                                        <IonLabel onClick={() => unCheckAll('stops-return-checkbox')}>لغو انتخاب همه</IonLabel>
                                    </div>
                                    <IonList lines="none" className="stops-return-checkbox">
                                        {state.routeReturn.stopsRouteReturn.map((item: any, index: number) =>
                                            <IonItem lines="none" key={'index' + index}>
                                                <span>
                                                    <IonCheckbox color="warning" value={item.value} checked={item.checked} onIonChange={(e) => checkCheckbox('stop-return-checkbox', index, e.detail.checked)} />
                                                    {item.title}
                                                </span>
                                            </IonItem>
                                        )}
                                    </IonList>
                                </div>
                            }
                            {item.type !== 'flightHotel' &&
                                <div className="flight-filter-modal-box box-range">
                                    <span className="my-title">
                                        قیمت بلیط
                                    </span>
                                    <IonRange
                                        id="priceRange"
                                        min={state.ticketPrice.min}
                                        max={state.ticketPrice.max}
                                        dualKnobs
                                        color="warning"
                                        dir="ltr"
                                        onIonChange={e => setRangeSlider('price-range', e.target as any)}
                                    >
                                        <IonLabel slot="start" className="range-label-start">
                                            <CurrencyFormat value={state.ticketPrice.lower} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                        </IonLabel>
                                        <IonLabel slot="end" className="range-label-end">
                                            <CurrencyFormat value={state.ticketPrice.upper} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                        </IonLabel>
                                    </IonRange>
                                </div>
                            }
                            <div className="flight-filter-modal-box">
                                <span className="my-title">
                                    ایرلاین ها {item.searchType === 'roundtrip' && '(پرواز رفت)'}
                                </span>
                                <div>
                                    <IonLabel onClick={() => checkAll('airlines-went-checkbox')}>انتخاب همه</IonLabel>
                                    /
                                    <IonLabel onClick={() => unCheckAll('airlines-went-checkbox')}>لغو انتخاب همه</IonLabel>
                                </div>
                                <IonList lines="none" className="airlines-went-checkbox">
                                    {state.routeWent.airlinesRouteWent.map((item: any, index: number) =>
                                        <IonItem lines="none" key={'index' + index}>
                                            <span>
                                                <IonCheckbox color="warning" value={item.code} checked={item.checked} onIonChange={(e) => checkCheckbox('airline-went-checkbox', index, e.detail.checked)} />
                                                <IonImg src={Constants.airlines + item.code + '.png'} />
                                                {item.name}
                                            </span>
                                        </IonItem>
                                    )}
                                </IonList>
                            </div>
                            {item.searchType === 'roundtrip' &&
                                <div className="flight-filter-modal-box">
                                    <span className="my-title">
                                        ایرلاین ها (پرواز برگشت)
                                    </span>
                                    <div>
                                        <IonLabel onClick={() => checkAll('airlines-return-checkbox')}>انتخاب همه</IonLabel>
                                        /
                                        <IonLabel onClick={() => unCheckAll('airlines-return-checkbox')}>لغو انتخاب همه</IonLabel>
                                    </div>
                                    <IonList lines="none" className="airlines-return-checkbox">
                                        {state.routeReturn.airlinesRouteReturn.map((item: any, index: number) =>
                                            <IonItem lines="none" key={'index' + index}>
                                                <span>
                                                    <IonCheckbox color="warning" value={item.code} checked={item.checked} onIonChange={(e) => checkCheckbox('airline-return-checkbox', index, e.detail.checked)} />
                                                    <IonImg src={Constants.airlines + item.code + '.png'} />
                                                    {item.name}
                                                </span>
                                            </IonItem>
                                        )}
                                    </IonList>
                                </div>
                            }
                            <div className="flight-filter-modal-box">
                                <span className="my-title">
                                    زمان حرکت {item.searchType === 'roundtrip' && '(پرواز رفت)'}
                                </span>
                                <div>
                                    <IonLabel onClick={() => checkAll('times-went-checkbox')}>انتخاب همه</IonLabel>
                                    /
                                    <IonLabel onClick={() => unCheckAll('times-went-checkbox')}>لغو انتخاب همه</IonLabel>
                                </div>
                                <IonList lines="none" className="times-went-checkbox">
                                    {timesListWent.map((item: any, index: number) =>
                                        <IonItem lines="none" key={'index' + index}>
                                            <span className="times-list-item">
                                                <span>
                                                    <IonCheckbox color="warning" value={item.value} checked={item.checked} onIonChange={(e) => checkCheckbox('time-went-checkbox', index, e.detail.checked)} />
                                                    {item.title + ' (' + item.subTitle + ')'}
                                                </span>
                                                <IonImg src={item.icon} />
                                            </span>
                                        </IonItem>
                                    )}
                                </IonList>
                            </div>
                            {item.searchType === 'roundtrip' &&
                                <div className="flight-filter-modal-box">
                                    <span className="my-title">
                                        زمان حرکت (پرواز برگشت)
                                    </span>
                                    <div>
                                        <IonLabel onClick={() => checkAll('times-return-checkbox')}>انتخاب همه</IonLabel>
                                        /
                                        <IonLabel onClick={() => unCheckAll('times-return-checkbox')}>لغو انتخاب همه</IonLabel>
                                    </div>
                                    <IonList lines="none" className="times-return-checkbox">
                                        {timesListReturn.map((item: any, index: number) =>
                                            <IonItem lines="none" key={'index' + index}>
                                                <span className="times-list-item">
                                                    <span>
                                                        <IonCheckbox color="warning" value={item.value} checked={item.checked} onIonChange={(e) => checkCheckbox('time-return-checkbox', index, e.detail.checked)} />
                                                        {item.title + ' (' + item.subTitle + ')'}
                                                    </span>
                                                    <IonImg src={item.icon} />
                                                </span>
                                            </IonItem>
                                        )}
                                    </IonList>
                                </div>
                            }
                            {item.type !== 'flightHotel' &&
                                <div className="flight-filter-modal-box box-range">
                                    <span className="my-title">
                                        طول پرواز {item.searchType === 'roundtrip' && '(پرواز رفت)'}
                                    </span>
                                    <IonRange
                                        id="durationWentRange"
                                        min={state.routeWent.durationRouteWent.min}
                                        max={state.routeWent.durationRouteWent.max}
                                        dualKnobs
                                        color="warning"
                                        dir="ltr"
                                        onIonChange={e => setRangeSlider('duration-went-range', e.target as any)}
                                    >
                                        <IonLabel slot="start" className="range-label-start">
                                            {MinutesToTime(state.routeWent.durationRouteWent.lower)}
                                        </IonLabel>
                                        <IonLabel slot="end" className="range-label-end">
                                            {MinutesToTime(state.routeWent.durationRouteWent.upper)}
                                        </IonLabel>
                                    </IonRange>
                                </div>
                            }
                            {item.searchType === 'roundtrip' &&
                                item.type !== 'flightHotel' &&
                                <div className="flight-filter-modal-box box-range">
                                    <span className="my-title">
                                        طول پرواز (پرواز برگشت)
                                    </span>
                                    <IonRange
                                        id="duratioReturnRange"
                                        min={state.routeReturn.durationRouteReturn.min}
                                        max={state.routeReturn.durationRouteReturn.max}
                                        dualKnobs
                                        color="warning"
                                        dir="ltr"
                                        onIonChange={e => setRangeSlider('duration-return-range', e.target as any)}
                                    >
                                        <IonLabel slot="start" className="range-label-start">
                                            {MinutesToTime(state.routeReturn.durationRouteReturn.lower)}
                                        </IonLabel>
                                        <IonLabel slot="end" className="range-label-end">
                                            {MinutesToTime(state.routeReturn.durationRouteReturn.upper)}
                                        </IonLabel>
                                    </IonRange>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="flight-filter-modal-footer-btns">
                        <IonButton color="primary" className="flight-filter-modal-confirm-btn" onClick={onConfirmModal}>تایید</IonButton>
                        <IonButton color="warning" onClick={() => setState({ ...state, showFlightFilterModal: false })} className="flight-filter-modal-close-btn">بستن</IonButton>
                    </div>
                </IonModal>
                :
                <Loading />
            }
            <span onClick={onOpenModal} className={item.disabled ? 'disabled' : ''}>
                <IonIcon icon={filterImg} />
                فیلتر
            </span>
        </>
    );
};
export default FlightFilter;